export default "__VITE_ASSET__DDAmwltK__"